/**
 * FERP Portal - Data Source Browser Page
 *
 * Thin page wrapper around the DataSourceBrowser component from workflow-forms.
 * Provides the unified chaos ingestion interface with 3 modes:
 *   1. Upload — drag-drop local files
 *   2. URL Fetch — enter a URL, server-side fetch + quarantine scan
 *   3. Adapter Sources — browse adapter web_sources, one-click fetch
 *
 * Plus LLM provider selection (AWS Bedrock / Ollama local)
 * and quarantine scan status display (4-stage security pipeline).
 *
 * FERP Principles:
 * - Dumb Frontend: All data from backend via hooks
 * - Mantine v8.x only
 * - Repository pattern for data access
 *
 * DRR-072: Feeds into chaos ingestion pipeline phases 0-8
 */

import { Container, Title, Text, Stack } from '@mantine/core';
import { DataSourceBrowser } from '@ferp/workflow-forms';

export function DataSourceBrowserPage() {
  return (
    <Container size="lg" py="md">
      <Stack gap="md">
        <div>
          <Title order={2}>Data Source Browser</Title>
          <Text size="sm" c="dimmed">
            Unified ingestion interface — upload files, fetch URLs, or browse adapter sources
          </Text>
        </div>

        <DataSourceBrowser
          onIngestionComplete={(result) => {
            console.log('Ingestion complete:', result);
          }}
        />
      </Stack>
    </Container>
  );
}
